/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'com.atlassian.migrations-platform.mpt-timeago.ui.just-now': 'alldeles nyss'
};